import React, { useState } from "react";
import { Button, Col, Container, Row } from "react-bootstrap";
import TableLayout from "../../../components/TableLayout";
import { Link, useLocation } from "react-router-dom";
import ConfirmationPop from "../../../components/Modals/ConfirmationPop";
import dataHandler from "../../../hooks/dataHandler";
import { HOTELDELETE, HOTELLIST } from "../../../services/ApiCalls";
import CustomPagination from "../../../components/Common/CustomPagination";
import TableActions from "../../../components/Common/TableActions";
import moment from "moment";
import Filter from "../../../components/Common/Filter";
import { activeInactiveOptions, csvImportEnum } from "../../../utilities/const";
import { exportCsvHandler } from "../../../utilities/utilities";
import Toggle from "../../../components/Common/Toggle";
import ImportCsv from "../../../components/Common/ImportCsv";
import ButtonLoader from "../../../components/Common/ButtonLoader";
import CountryFilter from "../../../components/Common/CountryFilter";
import { useTranslation } from "react-i18next";
import HotelStats from "../../../components/Common/HotelStats";
import HotelAdminFilter from "../../../components/Common/HotelAdminFilter";
import { useDispatch } from "react-redux";

const ManageHotel = () => {
  const [exportLoader, setExportLoader] = useState(false);
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const page = queryParams.get("page") || 1;
  const [hotelListStatus, setHotelListStatus] = useState("");
  const {
    setBody,
    body,
    data,
    statusChangeHandler,
    loader,
    deleteModel,
    setDeleteModel,
    paginationHandler,
    searchHandler,
    total,
    deleteHandler,
  } = dataHandler({
    api: HOTELLIST,
  });

  const handleDeleteHotel = async () => {
    const success = await deleteHandler(() => HOTELDELETE({ _id: deleteModel.dumpId }));
    if (success) {
      dispatch({ type: "REFRESH_HOTELS_LIST" });
    }
  };

  const columns = [
    {
      head: t("manageHotel.columns.serialNumber"),
      accessor: "#",
      component: (item, key) => {
        return <>{body.limit * (body.page - 1) + key + 1}</>;
      },
    },
    {
      head: t("manageHotel.columns.hotelName"),
      accessor: "hotelName",
      component: (item) => (
        <>
          {item.hotelName
            ? item.hotelName
            : t("manageHotel.placeholders.notAvailable")}
        </>
      ),
    },
    {
      head: t("manageHotel.columns.hotelId"),
      accessor: "hotelId",
      component: (item) => (
        <>
          {item.hotelId
            ? item.hotelId
            : t("manageHotel.placeholders.notAvailable")}
        </>
      ),
    },
    {
      head: t("manageHotel.columns.approvalStatus"),
      accessor: "label",
      component: (item) => <>{item?.isApproved ? "Yes" : "No"}</>,
    },
    // {
    //   head: t("manageHotel.columns.hotelPriority"),
    //   accessor: "label",
    //   component: (item) => (
    //     <>
    //       {item.pinStatus
    //         ? item.pinStatus?.label
    //         : t("manageHotel.placeholders.notAvailable")}
    //     </>
    //   ),
    // },
    // {
    //   head: t("manageHotel.columns.totalRooms"),
    //   accessor: "totalRoom",
    //   component: (item) => (
    //     <>
    //       {item?.totalRoom
    //         ? item?.totalRoom
    //         : t("manageHotel.placeholders.notAvailable")}
    //     </>
    //   ),
    // },
    {
      head: t("manageHotel.columns.availablity"),
      accessor: "name",
      component: (item) => (
        <>
          {item.availability ? (
            <span
              className={`badge ${item.availability === "Open" ? "bg-success" : "bg-secondary"
                }`}
            >
              {item.availability}
            </span>
          ) : (
            t("manageHotel.placeholders.notAvailable", "-")
          )}
        </>
      ),
    },

    {
      head: t("manageHotel.columns.mobileNumber"),
      accessor: "mobileNumber",
      component: (item) => (
        <span className="text-nowrap">
          {item?.countryCode
            ? `+${item.countryCode} ${item?.mobileNumber}`
            : item?.mobileNumber || t("manageHotel.placeholders.notAvailable")}
        </span>
      ),
    },
    {
      head: t("manageHotel.columns.email"),
      accessor: "email",
      component: (item) => (
        <span className="text-wrap">
          {item?.email
            ? item.email
            : t("manageHotel.placeholders.notAvailable")}
        </span>
      ),
    },
    {
      head: t("manageHotel.columns.location"),
      accessor: "address",
      component: (item) => {
        const words = item?.address?.split(" ");
        const truncatedText = words?.slice(0, 4).join(" ");
        const displayText =
          words?.length > 1
            ? `${truncatedText}...`
            : truncatedText || t("manageHotel.placeholders.notAvailable");
        return <span title={item?.address}>{displayText}</span>;
      },
    },
    {
      head: t("manageHotel.columns.country"),
      accessor: "country",
      component: (item) => {

        return <span >{item?.country}</span>;
      },
    },

    {
      head: t("manageHotel.columns.createdAt"),
      accessor: "createdAt",
      component: (item) => (
        <>
          {item.createdAt
            ? moment(item.createdAt).format("MM-DD-YYYY , HH:mm")
            : t("manageHotel.placeholders.notAvailable")}
        </>
      ),
    },
    // {
    //   head: t("manageHotel.columns.totalBookings"),
    //   accessor: "totalBookings",
    //   component: (item) => <>{item?.totalBookings ? item.totalBookings : t("manageHotel.placeholders.zero")}</>,
    // },
    {
      head: t("manageHotel.columns.status"),
      accessor: "status",
      title: t("manageHotel.statusTooltip"),
      component: (item, key) => (
        <p className={`rounded-pill px-2 py-1 m-0 hotel_${item?.status}`}>
          {item?.status}
        </p>
      ),
    },
    {
      head: t("manageHotel.columns.action"),
      accessor: "action",
      component: (item) => (
        <TableActions
          viewLink={`/hotel/detail/${item._id}`}
          editUrl={`/hotel/edit/${item._id}`}
          setDeleteModel={() =>
            setDeleteModel({ show: true, dumpId: item._id })
          }
        />
      ),
    },
  ];

  console.log(data, "data=======<>");

  return (
    <>
      <ConfirmationPop
        type={"delete"}
        confirmation={deleteModel.show}
        setConfirmation={() =>
          setDeleteModel({
            show: false,
            dumpId: "",
          })
        }
        confirmHandler={handleDeleteHotel}
      />

      <ConfirmationPop
        confirmation={deleteModel.show}
        setConfirmation={() => setDeleteModel({ show: false, dumpId: "" })}
        type={"delete"}
        confirmHandler={handleDeleteHotel}
      />
      <section className="manageServiceCategory  position-relative">
        <Container>
          <Row>
            <Col lg="12">
              <div className="d-flex justify-content-between align-items-center">
                <h4 className="mb-0 py-3 fw-bold text-dark text-capitalize">
                  {t("manageHotel.title")}
                </h4>
                <div className="right">
                  <ul className="list-unstyled ps-0 mb-0 d-flex align-items-center gap-10 flex-wrap">
                    {/* <li className="">
                      <ImportCsv
                        item={csvImportEnum.importHotel}
                        callBack={() => refetch()}
                        type="hotel"
                      />
                    </li>
                    <li className="">
                      <Button
                        className="d-flex align-items-center justify-content-center fw-sbold commonBtn GreyBtn"
                        style={{ height: 40, minWidth: 100, fontSize: 12 }}
                        type="button"
                        onClick={() =>
                          exportCsvHandler("hotel", setExportLoader, {
                            "status": hotelListStatus?.charAt(0)?.toUpperCase() + hotelListStatus?.slice(1),
                          })
                        }
                      >
                        {exportLoader ? (
                          <ButtonLoader />
                        ) : (
                          t("manageHotel.buttons.exportCsv")
                        )}
                      </Button>
                    </li> */}
                    <li className="">
                      <Link
                        to="/hotel/add"
                        className="d-flex btn btn-primary align-items-center justify-content-center fw-sbold commonBtn "
                        style={{ height: 40, minWidth: 100, fontSize: 12 }}
                      >
                        {t("manageHotel.buttons.addNewHotel")}
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </Col>
            {/* <Col lg="12" className="my-2">
              <HotelStats platformData={data?.platform} />
            </Col> */}

            <Col lg="12" className="my-2">
              <div className="tableFilter d-flex align-items-center justify-content-between flex-wrap gap-10 mb-3">
                <div className="left">
                  <HotelAdminFilter
                    body={body}
                    searchHandler={searchHandler}
                    setBody={setBody}
                    statusFilterOptionArr={activeInactiveOptions}
                    setFinanceStatus={setHotelListStatus}
                  // setFinanceSearch={setFinanceSearch}

                  />
                </div>
              </div>
            </Col>
            <Col lg="12" className="my-2">
              <TableLayout
                column={columns}
                data={data?.hotelList}
                loader={loader}
              />
              <CustomPagination
                total={total}
                pageChangeHandler={paginationHandler}
                body={body}
                setBody={setBody}
              />
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default ManageHotel;
